<template>
  <section class="c-login-content">
    <div class="card c-login-box">
      <h5 class="card-header bg-primary text-right text-white">{{ $t('login') }}</h5>
      <div class="card-body">
        <div class="c-login-box__label">{{ $t('welcome') }}</div>
        <form class="c-login-form" @submit="login">
          <div class="form-group mb-0 is-border-top">
            <b-form-input v-model="form.email" class="form-control form-control-lg" :placeholder="$t('emailPlaceholder')"></b-form-input>
          </div>
          <div class="form-group is-border-bottom">
            <b-form-input v-model="form.password" type="password" class="form-control form-control-lg" :placeholder="$t('passwordPlaceholder')"></b-form-input>
          </div>
          <div v-if="errors.length" class="alert alert-danger">
            <span v-for="error in errors" :key="error.param">{{ error.msg }}<br/></span>
          </div>
          <b-button :disabled="loading" variant="primary" size="lg" pill class="btn-block" type="submit">
            <b-spinner v-if="loading" small></b-spinner>
            <span v-else>{{ $t('login') }}</span>
          </b-button>
        </form>
        <div class="c-login-more">
<!--          <p>{{ $t('dontHaveAnAccount') }} <b><a href="#/register">{{ $t('registerNow') }}</a> |-->
            <a href="/forgot">{{ $t('forgot') }}</a>
<!--          </b></p><br/>-->
        </div>
      </div>
    </div>
    <lang></lang>
  </section>
</template>

<script>
import _ from 'lodash';
import Lang from "../../components/Lang";

export default {
  components: {Lang},
  data: function () {
    return {
      form: {},
      errors: {},
      loading: false
    }
  },
  methods: {
    login: function (evt) {
      evt.preventDefault();
      this.errors = {};
      this.loading = true;
      this.$service.post('/auth/login', this.form).then(response => {
        return this.$store.dispatch('login', response.data);
      }).then(() => {
        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect);
        } else {
          this.$router.push('/');
        }
      }).catch(error => {
        this.errors = error.response.data;
      }).finally(() => {
        _.delay(() => {
          this.loading = false;
        }, 250);
      });
    },
  },
  mounted() {
    if (this.$store.state.user !== null) {
      this.$router.push('/');
    }
  },
};
</script>
